<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li>Welcome</li>
            </ul>
            <h2>Welcome to Success Paramedical Institute</h2>
        </div>
    </div>
    <div class="shape9"><img src="images/shape8.svg" alt="image"></div>
</div>
<div class="profile-authentication-area ptb-100 d-flex align-items-center justify-content-center mb-5">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="register-form">
                    <h2>Register</h2>
                    <form>
                        <div class="form-group">
                            <label>Username</label>
                            <input type="text" class="form-control" placeholder="Username or email">
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" class="form-control" placeholder="Username or email">
                        </div>
                        <div class="form-group">
                            <label>Password</label>
                            <input type="password" class="form-control" placeholder="Password">
                        </div>
                        <p class="description">The password should be at least eight characters long. To make it
                            stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & )</p>
                        <button type="submit">Register</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>